// Public Module - Root Sagas
// This file aggregates all public-related sagas

import watchSignInSaga from './SignIn/store/saga'
import watchSignOutSaga from './SignOut/store/saga'

// Root saga for Public module
export default [
  watchSignInSaga(),
  watchSignOutSaga(),
]

